import { render } from "./inbc.vue?vue&type=template&id=13733b54&scoped=true"
import script from "./inbc.vue?vue&type=script&lang=js"
export * from "./inbc.vue?vue&type=script&lang=js"

import "./inbc.vue?vue&type=style&index=0&id=13733b54&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13733b54"]])

export default __exports__